import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lock/list',
        data,
        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lock/change-lock',
        data,
        method: 'post'
    })
};
// 下拉
export const fetchLessonList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lock/class-lesson',
        data,
        method: 'post'
    })
};
// 下拉班级
export const fetchClassList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/lock/class-list',
        data,
        method: 'post'
    })
};